export enum HttpCodeEnum {
	InternalServerError = "ERR_BAD_RESPONSE",
	TimeOut = "ECONNABORTED",
	Canceled = "ERR_CANCELED",
	ErrorNetwork = "ERR_NETWORK",
	ErrorTokenInvalidUser = "ERR_USER_TOKEN_INVALID",
}
